import { useLocation } from 'react-router';
import { Nav, SideNavItem } from 'components/navigation';
import {
  BuildingsIcon,
  FileTrayFullIcon,
  FinmoLogoIcon,
  GearIcon,
  LandmarkArrowsIcon,
  LandmarkIcon,
  MicrochipAiIcon,
  QuestionCircleIcon,
  ScaleUnbalancedIcon,
  SparkIcon,
  UserCircleIcon,
  WaveTriangleIcon,
} from 'icons';
import { hasUserNotification, useUser, userNotificationPathnames } from 'libs';

const Sidebar = () => {
  const { pathname } = useLocation();
  const user = useUser();
  const hasTeamDocumentsNotification = hasUserNotification(user, userNotificationPathnames.teamDocuments);
  const hasTeamAnnouncementsNotification = hasUserNotification(user, userNotificationPathnames.teamAnnouncements);

  return (
    <Nav className="side-navbar">
      <div className="side-navbar__links">
        <div className="side-navbar__navlinks">
          <SideNavItem
            icon={<WaveTriangleIcon />}
            isActive={pathname.startsWith('/rates')}
            label="Rates"
            name="rates"
            to="/rates"
          />
          <SideNavItem
            icon={<ScaleUnbalancedIcon />}
            isActive={pathname.startsWith('/scenarios')}
            label="Scenarios"
            name="scenarios"
            to="/scenarios/comparisons"
          />
          <SideNavItem
            icon={<LandmarkIcon />}
            isActive={pathname.startsWith('/lenders')}
            label="Lenders"
            name="lenders"
            to="/lenders"
          />
          <SideNavItem
            icon={<FileTrayFullIcon />}
            isActive={pathname.startsWith('/guidelines')}
            label="Policies"
            name="guidelines"
            to="/guidelines"
          />
          <SideNavItem
            icon={<LandmarkArrowsIcon />}
            isActive={pathname.startsWith('/alternative-lending')}
            label="Alternative Lending"
            name="alternative-lending"
            state={{ hydratePrevState: true }}
            to="/alternative-lending"
          />
          <SideNavItem
            icon={<MicrochipAiIcon />}
            isActive={pathname === '/ai'}
            label="AI Assistant"
            name="ai"
            to="/ai"
          />
          {user.features.laravel_ai && (
            <SideNavItem
              icon={<SparkIcon />}
              isActive={pathname.startsWith('/ai/conversations')}
              label="Spotlight Spark"
              name="conversations"
              to="/ai/conversations"
            />
          )}
          {user.features.has_brokerage && (
            <SideNavItem
              hasNotification={hasTeamAnnouncementsNotification || hasTeamDocumentsNotification}
              icon={<BuildingsIcon />}
              isActive={pathname.startsWith('/teams')}
              label="Team"
              name="teams"
              to="/teams"
            />
          )}
          {user.features.is_brokerage_admin && (
            <SideNavItem
              icon={<GearIcon />}
              isActive={pathname.startsWith('/team-management')}
              label="Team Management"
              name="team-management"
              to="/team-management"
            />
          )}
          <SideNavItem
            icon={<QuestionCircleIcon />}
            isExternalRoute
            label="Help Centre"
            name="help-centre"
            shouldOpenNewWindow
            to="https://support.lenderspotlight.ca"
          />
        </div>
        <div className="side-navbar__settings">
          <SideNavItem
            icon={<FinmoLogoIcon />}
            isExternalRoute
            label="Switch To Finmo"
            name="finmo"
            shouldOpenNewWindow
            to="https://app.finmo.ca"
          />
          <SideNavItem
            icon={<UserCircleIcon />}
            isActive={pathname.startsWith('/settings')}
            label="Your account"
            name="profile"
            to="/settings"
          />
        </div>
      </div>
    </Nav>
  );
};

export default Sidebar;
